import { create } from "zustand";

import axios from "../helper/axios";

const useStatsStore = create((set) => ({
    graphsGroupUserStats: null,
    graphsGroupAllStats:null,
    unreadNotifications: 0,
    newNotificationIndices: null,

    //team dashboard
    teamsDashConsolidatedStats: null,
    teamsDashConsolidatedStatsCount:0,
    teamsDashConsolidatedStatsResumesShared: null,
    teamsDashConsolidatedStatsResumesSharedCount:0,
    teamsDashConsolidatedStatsInterviewScheduling: null,
    teamsDashConsolidatedStatsInterviewSchedulingCount:0,
    teamsDashConsolidatedStatsPositiveFeedback: null,
    teamsDashConsolidatedStatsPositiveFeedbackCount:0,
    teamsDashConsolidatedStatsNegativeFeedback: null,
    teamsDashConsolidatedStatsNegativeFeedbackCount:0,
    teamsDashConsolidatedStatsSelectionAndOffers: null,
    teamsDashConsolidatedStatsSelectionAndOffersCount:0,                

    //internal
    teamsInternalConsolidatedStats:null,
    teamsInternalConsolidatedCount:0,
    jdsConsolidatedStats:null,
    jdsConsolidatedStatsCount:0,
    allJdsInternalConsolidatedStats:null,
    totalJDsInternalConsolidate:0,

    //mydashboard 
    myDashConsolidatedStats: null,
    myDashConsolidatedStatsCount:0,
    myDashConsolidatedStatsResumesShared: null,
    myDashConsolidatedStatsResumesSharedCount:0,
    myDashConsolidatedStatsInterviewScheduling: null,
    myDashConsolidatedStatsInterviewSchedulingCount:0,
    myDashConsolidatedStatsPositiveFeedback: null,
    myDashConsolidatedStatsPositiveFeedbackCount:0,
    myDashConsolidatedStatsNegativeFeedback: null,
    myDashConsolidatedStatsNegativeFeedbackCount:0,
    myDashConsolidatedStatsSelectionAndOffers: null,
    myDashConsolidatedStatsSelectionAndOffersCount:0,
    //
    myInternalConsolidatedStats:null,
    myInternalConsolidatedCount:0,
    interviewSchedules:null,
    allSelections: null,
    allSelectionsJds: null,
    mySelections: null,
    mySelectionsJds: null,
    allSelectionsResumes:null,
    mySelectionsResumes:null,
    totalJDCount:0,

    autoResumeMatchingStats:null,
    totalResumesAutoMatching:0,
    autoResumeMatchingLinkRefresh:false,
    linkedAutoResumeMatchingStats:null,
      
  getGraphsGroupUserStats: async (duration,data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.post(`/getGraphGroupActivity/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
           console.log(response.data.name);  
           //console.log(response.data.data);

            const newStats = response?.data?.data;

            set((state) => {
                if (newStats?.useractivity === null) {
                  return {
                    graphsGroupUserStats: newStats,
                  };
                }

                const changedIndicesSet = new Set(state.newNotificationIndices || []);

                newStats?.useractivity?.forEach((newObj, index) => {
                    const oldObj = state?.graphsGroupUserStats?.useractivity?.[index];
                    if(!oldObj || JSON.stringify(newObj) !== JSON.stringify(oldObj)){
                        //console.log(index);
                        changedIndicesSet.add(index);
                    }
                });
                //console.log(changedIndicesSet, "this is changedIndicesSet");

        const hasChanged =
          JSON.stringify(state.graphsGroupUserStats?.useractivity) !==
          JSON.stringify(newStats?.useractivity);
        return {
          newNotificationIndices: changedIndicesSet,
          graphsGroupUserStats: newStats,
          unreadNotifications: hasChanged
            ? state.unreadNotifications + 1
            : state.unreadNotifications,
        };
      });
    } catch (err) {
      console.error(err);
    }
  },

  getGraphsAllStats: async (data) => {
        try {
          console.log("getGraphsAllStats",data);  
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.post(`/getGraphAllActivity/${userData.account_type}/${userData.qhoid}/${userData.qhuid}`,data);
           //console.log(response.data.name);  
           //console.log(response.data.data);
           set({ graphsGroupAllStats: response?.data.data });

    } catch (err) {
      console.error(err);
    }
  },  
  getTeamsDashBoardConsolidatedStats: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //console.log(data);
      const response = await axios.post(
        `/getTeamDashBoardConsolidated/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ teamsDashConsolidatedStats: response?.data.data });
      set({ teamsDashConsolidatedStatsCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },
  getTeamsDashBoardConsolidatedStatsResumesShared: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //console.log(data);
      const response = await axios.post(
        `/getTeamDashBoardConsolidatedResumeShared/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ teamsDashConsolidatedStatsResumesShared: response?.data.data });
      set({ teamsDashConsolidatedStatsResumesSharedCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },
  getTeamsDashBoardConsolidatedStatsPositiveFeedbacks: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //console.log(data);
      const response = await axios.post(
        `/getTeamDashBoardConsolidatedPositiveFeedbacks/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ teamsDashConsolidatedStatsPositiveFeedback: response?.data.data });
      set({ teamsDashConsolidatedStatsPositiveFeedbackCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },

  getTeamsDashBoardConsolidatedStatsNegativeFeedback: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //console.log(data);
      const response = await axios.post(
        `/getTeamDashBoardConsolidatedNegaiveFeedbacks/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ teamsDashConsolidatedStatsNegativeFeedback: response?.data.data });
      set({ teamsDashConsolidatedStatsNegativeFeedbackCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },

  getTeamsDashBoardConsolidatedStatsInterviewScheduling: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //console.log(data);
      const response = await axios.post(
        `/getTeamDashBoardConsolidatedInterviewScheduling/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ teamsDashConsolidatedStatsInterviewScheduling: response?.data.data });
      set({ teamsDashConsolidatedStatsInterviewSchedulingCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },
  getTeamsDashBoardConsolidatedStatsSelectionAndOffers: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //console.log(data);
      const response = await axios.post(
        `/getTeamDashBoardConsolidatedSelectionAndOffers/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ teamsDashConsolidatedStatsSelectionAndOffers: response?.data.data });
      set({ teamsDashConsolidatedStatsSelectionAndOffersCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },          

  getTeamsInternalConsolidatedStats: async (duration,data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.post(`/getTeamInternalConsolidated/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
            //console.log(response.data.name); 
            //console.log(response.data.data);
            //console.log(response.data.totalCount);
            set({ teamsInternalConsolidatedStats: response?.data.data });
            set({ teamsInternalConsolidatedCount: response?.data.totalCount });
        } catch (err) {
            console.error(err);
        }
    }, 
    getAllJdsInternalConsolidatedStats: async (duration,data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           //console.log(data);
           const response = await axios.post(`/getAllJdsInternalConsolidated/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
           //console.log(response.data.name); 
           //console.log(response.data.data);
           set({ allJdsInternalConsolidatedStats: response?.data.data });
           set({ totalJDsInternalConsolidate: response?.data.totalCount });
        } catch (err) {
            console.error(err);
        }
    },     
    getJdsConsolidatedStats: async (filterDuration, data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           //console.log(data);
           const response = await axios.post(`/getJdsConsolidated/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${filterDuration}`,data);
           //console.log(response.data.name); 
           //console.log(response.data.data);
           //console.log("count",response.data.count);
           set({ jdsConsolidatedStats: response?.data.data });
           set({ jdsConsolidatedStatsCount: response?.data.count });
           
           //console.log(response.data.data);
        } catch (err) {
            console.error(err);
        }
    },

  getMyDashBoardConsolidatedStats: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      ////console.log(data);
      const response = await axios.post(
        `/getMyDashBoardConsolidated/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ myDashConsolidatedStats: response?.data.data });
      set({ myDashConsolidatedStatsCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },
  getMyDashBoardConsolidatedStatsResumesShared: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      ////console.log(data);
      const response = await axios.post(
        `/getMyDashBoardConsolidatedResumesShared/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ myDashConsolidatedStatsResumesShared: response?.data.data });
      set({ myDashConsolidatedStatsResumesSharedCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },  
  getMyDashBoardConsolidatedStatsPositiveFeedbacks: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      console.log(data);
      const response = await axios.post(
        `/getMyDashBoardConsolidatedPositiveFeedbacks/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ myDashConsolidatedStatsPositiveFeedback: response?.data.data });
      set({ myDashConsolidatedStatsPositiveFeedbackCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },  
  getMyDashBoardConsolidatedStatsNegativeFeedback: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      ////console.log(data);
      const response = await axios.post(
        `/getMyDashBoardConsolidatedNegativeFeedbacks/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      console.log(response.data.name);
      //console.log(response.data);
      set({ myDashConsolidatedStatsNegativeFeedback: response?.data.data });
      set({ myDashConsolidatedStatsNegativeFeedbackCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },  
  getMyDashBoardConsolidatedStatsInterviewScheduling: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //console.log(data);
      const response = await axios.post(
        `/getMyDashBoardConsolidatedInterviewScheduling/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ myDashConsolidatedStatsInterviewScheduling: response?.data.data });
      set({ myDashConsolidatedStatsInterviewSchedulingCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  }, 
    getMyDashBoardConsolidatedStatsSelectionAndOffers: async (duration,data) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userDetails"));
      //console.log(data);
      const response = await axios.post(
        `/getMyDashBoardConsolidatedSelectionAndOffers/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
      //console.log(response.data.name);
      //console.log(response.data);
      set({ myDashConsolidatedStatsSelectionAndOffers: response?.data.data });
      set({ myDashConsolidatedStatsSelectionAndOffersCount: response?.data.totalCount });
    } catch (err) {
      console.error(err);
    }
  },             
  getMyInternalConsolidatedStats: async (duration,data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.post(`/getMyInternalConsolidated/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`,data);
           //console.log(response.data.name); 
           //console.log(response.data.data);
           set({ myInternalConsolidatedStats: response?.data.data });
           set({ myInternalConsolidatedCount: response?.data.totalCount });
        } catch (err) {
            console.error(err);
        }
    },
    
    getInterviewSchedule: async () => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.get(`/getInterviewSchedule/${userData.account_type}/${userData.qhoid}/${userData.qhuid}`);
           //console.log(response.data.name); 
           //console.log(response.data.data);
            set({ interviewSchedules: response?.data.data });
        } catch (err) {
            console.error(err);
        }
    },

    getAutoResumeMatching: async (jdid, filterParams ,  pageNumber , limit ,duration) => {
      try {
        const userData = JSON.parse(localStorage.getItem("userDetails"));

          //reset old data
          set({linkedAutoResumeMatchingStats: null });
          set({autoResumeMatchingStats: null });
          set({totalResumesAutoMatching: 0});          
          //console.log(data);
          // Merge user provided filters with defaults
          const finalFilters = { 
            ...filterParams,
            ...(pageNumber && { pageNumber }),
            ...(limit && { limit })
          };
        

          const response = await axios.get(
            `/autoresumematching/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${jdid}/${duration}`,
             {
              params: finalFilters,
              paramsSerializer: (params) => {
                return Object.entries(params)
                  .map(([key, value]) => {
                    if (Array.isArray(value)) {
                      return value
                        .map(
                          (v) =>
                            `${encodeURIComponent(key)}=${encodeURIComponent(v)}`
                        )
                        .join("&");
                    }
                    return `${encodeURIComponent(key)}=${encodeURIComponent(
                      value
                    )}`;
                  })
                  .join("&");
              },
            }
            // axios expects params object inside an options object
           );           

           //console.log(response.data.name);  
           //console.log(response.data.data);
           set({autoResumeMatchingStats: response?.data.data });
           set({totalResumesAutoMatching: response?.data.totalCount});

        } catch (err) {
            console.error(err);
        }
    },  
       
    linkAutoResumeMatching: async (body) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           const response = await axios.post(`/automaticresumematchinglinkjd/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${body.qhjid}`,body.jasonValues);
           //console.log(response);  
           console.log(response.data.name);  
           console.log(response.data.data);

           if(body.linkCB != null){
                const resData = body.linkCB(response.data.data)
                set({linkedAutoResumeMatchingStats: resData });
           }else{
            set({linkedAutoResumeMatchingStats: null });
           } 
           
           if(response?.data.refresh === true){
              set({autoResumeMatchingLinkRefresh: true });
           }else{
              set({autoResumeMatchingLinkRefresh: false });
           }
           
        } catch (err) {
            console.error(err);
        }
    },  
    resetAutoResumeMatchingLinkRefresh: () => set({ autoResumeMatchingLinkRefresh: false }),
    markNotificationAsRead: () => set({ unreadNotifications: 0 }),

    clearNotificationIndices: () => set({ newNotificationIndices: null }),

    getMySelectionStats: async (duration) => {
      try {
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        const response = await axios.get(`/getMySelectedApplications/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`);
        //console.log(response.data.name); 
        set({ mySelections: response?.data.data });
        set({ mySelectionsJds: response?.data.jds });
        set({ mySelectionsResumes: response?.data.resumes }); 
      } catch (err) {
          console.error(err);
      }
     },

     getAllSelectionStats: async (duration) => {
      try {
         const userData = JSON.parse(localStorage.getItem("userDetails"));
         const response = await axios.get(`/getAllSelectedApplications/${userData.account_type}/${userData.qhoid}/${userData.qhuid}/${duration}`);
         //console.log(response.data.name); 
         //console.log("Selection data",response.data.data);
         //console.log("Selection JDs",response.data.jds);
         set({ allSelections: response?.data.data });
         set({ allSelectionsJds: response?.data.jds }); 
         set({ allSelectionsResumes: response?.data.resumes });   
      } catch (err) {
          console.error(err);
      }
  },     

  checkProfilePicture: () => {
    const userData = JSON.parse(localStorage.getItem("userDetails")) || {};
    const hasPicture = Boolean(userData?.company_logo?.trim?.());

    if (!hasPicture) {
      set((state) => ({ unreadNotifications: state.unreadNotifications + 1 }));
    }
  },

}));

export default useStatsStore;
